<template>
    <span>
    <section class="pb-8" id="contacto">

        <v-container fluid>

            <v-row class="titulo_section">
                <v-col cols="12" sm="12">
                    <h1 class="font-weight-bold display-1" align="center">Contacto</h1>
                </v-col>
            </v-row>


            <v-row align="center" justify="center">
                <v-col cols="10">
                    <v-row justify="center">

                        <v-col cols="12" sm="5" class="pt-6"  >

                            <!-- 
                                <i class="fas fa-map-marked-alt"></i>
                                Version 6-
                                <FontAwesomeIcon icon="fa-solid fa-location-dot" />
                                <FontAwesomeIcon icon="fa-solid fa-map-location-dot" />
                                <FontAwesomeIcon icon="fa-solid fa-phone" />
                                <FontAwesomeIcon icon="fa-solid fa-square-phone" />
                                <FontAwesomeIcon icon="fa-regular fa-envelope" />
                                <FontAwesomeIcon icon="fa-solid fa-envelope" />
                                fas fa-map-marked-alt
                            -->

                            <v-card shaped :elevation="hover ? 10 : 4" :class="{ up: hover }"  >
                                <v-row>
                                    <v-col cols="3">
                                        <div class="d-flex align-start" style="font-size: 0.9rem;"> 
                                            <span v-on="on" class="fa-stack fa-2x">
                                                <i class="fas fa-circle fa-stack-2x color02"></i>
                                                <i class="fas fas fa-map-marked-alt fa-stack-1x fa-inverse"></i>
                                            </span>
                                          
                                        </div>
                                    </v-col>
                                    <v-col cols="9">
                                        <h3 class="font-weight">Dirección</h3>
                                        <h4 class="font-weight-light">
                                            Venezuela edo Carabobo Valencia 
                                            <!-- Urb. Parque Valencia, sector 32 calle #79 Venezuela -->
                                        </h4> 
                                    </v-col>                                
                                </v-row>
                                
                                <v-row>
                                    <v-col cols="3">
                                        <div class="d-flex align-start"  style="font-size: 0.9rem;"> 
                                            <span v-on="on" class="fa-stack fa-2x">
                                                <i class="fas fa-circle fa-stack-2x color02"></i>
                                                <i class="fas fa-phone fa-stack-1x fa-inverse"></i>
                                            </span>                                            
                                        </div>                                        
                                    </v-col>
                                    <v-col cols="9">
                                        <h3 class="font-weight">Teléfono</h3>
                                        <h4 class="font-weight-light">
                                            Telf.: +58 412-9151949
                                        </h4>  
                                    </v-col>                                
                                </v-row>
                                
                                <v-row>
                                    <v-col cols="3">
                                        <div class="d-flex align-start"  style="font-size: 0.9rem;"> 
                                            <span v-on="on" class="fa-stack fa-2x">
                                                <i class="fas fa-circle fa-stack-2x color02"></i>
                                                <i class="fas fa-envelope fa-stack-1x fa-inverse"></i>
                                            </span>
                                        </div>
                                    </v-col>
                                    <v-col cols="9">
                                        <h3 class="font-weight">Correo Electrónico</h3>
                                        <h4 class="font-weight-light">
                                            wuilmergarciac@gmail.com
                                        </h4> 
                                    </v-col>                                
                                </v-row>
                                
                                <!--
                                <v-col cols="12">
                                    <h3 class="font-weight">Ubicanos</h3>
                                    <div class="img_map d-flex justify-center"><a @click="$vuetify.goTo('#Ubicacion')" ><img src="@/assets/google_map.png" height="100px" white="100px"></a></div>
                                </v-col>   
                                -->
                                
                            </v-card>
                            </v-col>
                       

                        <v-col cols="12" sm="7">
                             <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                <v-row class="pt-3">
                                    <v-col cols="12" class="py-0">
                                        <v-text-field v-model="contacto.nombre" label="Nombres y apellidos" dense filled 
                                            :rules="[validation.required, validation.min6]"  required ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="py-0">
                                        <v-text-field v-model="contacto.email" label="Correo Electrónico" type="email" dense filled 
                                            :rules="[validation.required, validation.email]"   required ></v-text-field> 
                                    </v-col>
                                    <v-col cols="12" class="py-0">
                                        <v-text-field v-model="contacto.telefono" label="Teléfono" dense filled
                                            :rules="[validation.required, validation.min10 ]"   required >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="py-0">
                                        <v-textarea v-model="contacto.mensaje" label="Mensaje" rows="3" dense filled
                                            :rules="[validation.required, validation.min20]"  required />    
                                    </v-col>
                                </v-row>
                                
                                
                                <!--
                                    <v-btn class="btn_block_style2" :loading="loading" dark tile v-if="this.evento=='agregar'" @click="saveItem">Guardar</v-btn>
                                -->

                                <v-col class="d-flex justify-end pt-0">
                                    <v-btn :loading="loading"  :dark="valid" rounded class="mt-3 btn_secondary"
                                       @click="saveItem" >
                                    Enviar
                                </v-btn>
                                </v-col>

                                </v-form>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>   
        </v-container>


        <div class="svg-border-waves text-white">
            <v-img  :src="require('@/assets/img/borderWaves.svg')"/>
        </div>




        <!--
        <div class="google-map"><iframe frameborder="0" style="border:0" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyA0Dx_boXQiwvdz8sJHoYeZNVTdoWONYkU&amp;q=place_id:ChIJwbCerIZngI4RFBa4afKF5jA" allowfullscreen=""></iframe></div>  -->

    </section>

    <!--
    
    <section class="pb-8" id="Ubicacion">

        <v-container fluid>

            <v-row class="titulo_section">
                <v-col cols="12" sm="12">
                    <h1 class="font-weight-bold display-1" align="center">Ubicanos</h1>
                </v-col>
            </v-row>
            <div class="map-responsive d-flex justify-center">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1963.657512897244!2d-67.9588742!3d10.1550279!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e8067d36f431c9d%3A0x2790a87ed7741e36!2sColegio%20de%20Enfermeras!5e0!3m2!1ses!2sve!4v1705838134519!5m2!1ses!2sve" 
                    width="600" height="450" frameborder="0"  style="border:0" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                </iframe>
            </div>

        </v-container>
    </section>

    -->
    </span>
</template>





<script>
    // import {db} from '@/main'
    import {mapMutations} from 'vuex';
    import axios from '@/helpers/axios'
    import { validation } from "@/helpers/validator.js";

    export default {
        data: () => ({

            loading:false,

            icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
            valid: true,
            name: "",

            contacto:{},

            emailRules: [
                (v) => !!v || "O campo email é obrigatório",
                (v) => /.+@.+\..+/.test(v) || "O E-mail precisa ser válido",
            ],


            lazy: false,

        }),

        computed:{
            validation() {
                return validation;
            },
        },




        methods: {

            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),

            async saveItem() {

            if (this.$refs.form.validate()) {

                    try {
                        this.loading=true
                        let params = this.contacto
                        const resp = await axios.post("/sistema/mail/sendMail",params);

                        this.loading=false
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})
                        this.limpiarForm();

                    }catch (e) {

                        if (e.response) {
                            this.loading=false
                            let resp = e.response.data
                            console.log(resp)
                            this.loading=false
                            this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})
                        }


                    }
                }else{
                    let mens ="Debe Ingresar todos los campos requerido"
                    this.setEnviarMens({tipo:"W", mensaje: `${mens}`, tiempo:null})

                }
            },


            limpiarForm(){
                this.contacto = {
                        nombre:"", email:"", telefeno:"", mensaje:""
                }

            },


        }
    };
</script>



<style scoped>

 
    .fa-phone:hover, .fa-map-marked-alt:hover, .fa-envelope:hover {
        color:var(--color_main) !important;
        
    }
    /*
    .color02{
        color:  var(--color_secondary) !important;
        transition:all .5s ease-in-out;
    }

    .color02:hover{
        color:  var(--color_main) !important;
        background-color: var(--color_secondary2) ;
        transition: all 250ms linear;
        transform: scale(1.1);
    }
   */

   #contacto {
       background-color: var( --background);  
   
    }

     


    .svg-border-waves .v-image {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 3rem;
        width: 100%;
        overflow: hidden;
    }


    .map-responsive{
        overflow:hidden;
        padding-bottom:56.25%;
        position:relative;
        height:0;
    }

    .map-responsive iframe{
        /*left:0;
        top:0;
        */
        height:80%;
        width:90%;
        position:absolute;
    }

</style>
